import * as React from 'react';
import { useSelector } from 'react-redux';

import { Intro } from '../../components/Intro';
import { SaleRentIntro } from '../../components/SaleRentIntro';
import { formContextObj } from '../FormContainer';
import { selectIntro } from '../../selectors/selectIntro';
import { EPartnerUtmSource, INTRO_SCREEN_PARTNER_LOGO } from '../../constants/partners';
import { isAbExperiment } from '../../utils/abuse';
import { selectAbUseExperiments } from '../../selectors/selectAbUseExperiments';
import { FIND_REALTOR_AUTHORIZATION } from '../../constants/experiments';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectUser } from '../../selectors/selectUser';
import { goToAuthentication } from './utils';
import { NBSP } from '../../constants/symbols';
import { IIntroValues } from '../../types/redux/intro';
import { isSpecialIntoCase } from '../../utils/isSpecialIntoCase';

const CONTENT = {
  title: 'Бесплатно подберём\nнадёжного риелтора',
  steps: [
    `Заполните короткую анкету — это${NBSP}займёт пару минут`,
    `По${NBSP}анкете вам${NBSP}перезвонят максимум 3${NBSP}риелтора: обсудите детали и${NBSP}цены`,
    `Выберете подходящего риелтора и${NBSP}начнёте работу`,
  ],
  submitText: 'Заполнить анкету',
};

const getPartnerIcon = (intro: IIntroValues): string | undefined => {
  switch (true) {
    case intro.fromAlfaBank:
      return INTRO_SCREEN_PARTNER_LOGO[EPartnerUtmSource.AlfaBank];
    case intro.fromN1:
      return INTRO_SCREEN_PARTNER_LOGO[EPartnerUtmSource.N1];
    case intro.fromBankiru:
      return INTRO_SCREEN_PARTNER_LOGO[EPartnerUtmSource.Bankiru];
    default:
      return undefined;
  }
};

export const IntroContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { config } = useApplicationContext();

  const { startQuiz } = React.useContext(formContextObj);

  const isNeedAuthorizationStart = isAbExperiment(useSelector(selectAbUseExperiments), FIND_REALTOR_AUTHORIZATION, 'B');
  const { userId } = useSelector(selectUser);
  const intro = useSelector(selectIntro);

  const onIntroSubmit = () => {
    if (!userId && isNeedAuthorizationStart && !isSpecialIntoCase(intro)) {
      goToAuthentication(config);

      return;
    }

    startQuiz();
  };

  if (intro.fromSaleRent) {
    return <SaleRentIntro />;
  }

  return (
    <Intro
      title={CONTENT.title}
      partnerIcon={getPartnerIcon(intro)}
      steps={CONTENT.steps}
      submitText={CONTENT.submitText}
      onSubmit={onIntroSubmit}
    />
  );
};

IntroContainer.displayName = 'IntroContainer';
